const checkTitleSize = () => {
    if(document.querySelector('.wp-block-ume-ume-split-header-featured-block')){
        const holder = document.querySelector('.wp-block-ume-ume-split-header-featured-block');
        const title = holder.querySelector('h1');

        if (Array.from(title.innerText.replace(/(\&shy;|­|&#173;)/gi, "")).length > 60){
            let factor = 0.8;
            if(Array.from(title.innerText.replace(/(\&shy;|­|&#173;)/gi, "")).length > 80) factor = 0.6;
            let styling = getComputedStyle(title);

            let fontSize = styling.fontSize;
            let newFontSize = factor*parseInt(fontSize);
            title.setAttribute('style', `font-size: ${Math.floor(newFontSize) > 16 ? Math.floor(newFontSize) : 16}px`);
        }
    }
}
export default  checkTitleSize;